// extracted by mini-css-extract-plugin
module.exports = {"OverviewPage":"OverviewPage_OverviewPage__I69D5"};